export default __webpack_public_path__ + "static/WFAM-logo-colored-dacec74f94cd4a647f92995783d853e5.svg";